import { render, staticRenderFns } from "./training-modal.vue?vue&type=template&id=3543f2ae&scoped=true&"
import script from "./training-modal.vue?vue&type=script&lang=js&"
export * from "./training-modal.vue?vue&type=script&lang=js&"
import style0 from "./training-modal.vue?vue&type=style&index=0&id=3543f2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543f2ae",
  null
  
)

export default component.exports